import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/documents")({
  staticData: { breadcrumb: "Documents" },
})
